import {ConsultationGroup, Images} from '@/constants';
import React from 'react';
import {Button} from '@/ui-kits';
import {Routes} from '@/navigation/Routes';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {authDataSelector} from '@/services/redux/selectors';
import { formatName } from '@/utils/common_functions';

interface NoConsultationsProps {
  tab: ConsultationGroup;
}
interface Message {
  title: string;
  description: string;
}
export const NoConsultations: React.FC<NoConsultationsProps> = props => {
  const {tab} = props;
  const navigate = useNavigate();
  const user = useSelector(authDataSelector);

  const handleNavigateToUpload = () => {
    navigate(Routes.DASHBOARD);
  };

  const messages: Record<ConsultationGroup, Message> = {
    [ConsultationGroup.Ongoing]: {
      title: `Welcome, ${formatName(user?.username || '')}!`,
      description:
        'To get started with your healthcare journey, upload your medical reports for better guidance.',
    },
    [ConsultationGroup.Past]: {
      title: 'No Past Consultations Yet!',
      description:
        'There are no completed consultations at the moment. Please complete one to view it here.',
    },
    [ConsultationGroup.ConsultationHistory]: {
      title: 'No History Available !',
      description:
        'You have no consultation history yet. Once you complete a consultation, it will appear here.',
    },
  };

  return (
    <div className="bg-white rounded-3xl grow shadow-lg border border-ui_grey p-12 flex flex-col items-center justify-center min-h-[500px]">
      {tab === ConsultationGroup.Ongoing && (
        <div className="mb-8">
          <img
            src={Images.no_ongoing_consultations}
            alt="No consultations"
            className="w-96 h-auto"
          />
        </div>
      )}
      {messages[tab].title && (
        <h2 className="text-3xl font-FigtreeBold text-ui_blue mb-4 text-center">
          {messages[tab].title}
        </h2>
      )}
      {messages[tab].description && (
        <p className="text-ui_blue text-center mb-8 max-w-2xl font-FigtreeRegular">
          {messages[tab].description}
        </p>
      )}
      {tab === ConsultationGroup.Ongoing && (
        <Button
          title="Go to Upload"
          variant="primary"
          onClick={handleNavigateToUpload}
          className="px-8 py-3 rounded-lg hover:bg-ui_blue_light/10 transition-colors"
        />
      )}
    </div>
  );
};
